import { VersionType } from '../documents/enums';
import { Field, Page, Document } from '../documents/types';

export const _generateRandomDocumentName = (id: number): string => {
  const prefixes = ['Report', 'Memo', 'Plan', 'Analysis', 'Proposal'];
  const subjects = ['Project', 'Budget', 'Marketing', 'Sales', 'Research'];
  const suffixes = ['2023', 'Q1', 'Q2', 'Q3', 'Q4', 'Draft', 'Final'];

  const prefix = prefixes[Math.floor((id * 17) % prefixes.length)];
  const subject = subjects[Math.floor((id * 17) % subjects.length)];
  const suffix = suffixes[Math.floor((id * 17) % suffixes.length)];

  return `${prefix} - ${subject} ${suffix}`;
};

export const getField = (
  type: number,
  name?: string,
  value?: string,
): Field => {
  return {
    name: name ?? '',
    pageId: `/mocks/image-0${type}.webp?id=${crypto.randomUUID()}`,
    createdAt: '',
    updatedAt: '',
    value: {
      current: value ?? '',
      initial: '',
      confidence: 95,
      userValidated: false,
      crossValidated: false,
    },
    coordinates: {
      top: 10,
      left: 10,
      bottom: 10,
      right: 10,
    },
  };
};

export const _getPageIdsAndFields = (
  id: number,
): { pages: Page[]; fields: Field[] } => {
  const pages = Array.from(
    { length: ((id * 13) % 7) + 10 },
    (_, pageIndex) => (pageIndex % 2) + 1,
  );
  return {
    pages: pages.map((pageType) => ({
      id: crypto.randomUUID(),
      thumbnailUrl: `/mocks/image-0${pageType}.webp?id=${crypto.randomUUID()}`,
      number: 1,
      height: 1000,
      width: 800,
      dpix: 300,
      dpiy: 300,
      pdfUrl: `/mocks/image-0${pageType}.webp?id=${crypto.randomUUID()}`,
      imageUrl: `/mocks/image-0${pageType}.webp?id=${crypto.randomUUID()}`,
      classification: 'Invoice',
      classificationConfidence: 0.95,
      pageId: crypto.randomUUID(), // Ensure each page has a unique ID
      pageOrder: 1,
    })),
    fields: pages.flatMap((type) => {
      if (type === 1) {
        return [
          getField(type, 'Application Fee', '500'),
          getField(type, 'Appraisal Field', 'N/A'),
          getField(type, 'Credit report fee', 'N/A'),
        ];
      }
      return [getField(type, 'Property type', 'Residential')];
    }),
  };
};

export const _mockDocumentType = {
  id: `document-type-id-mock-document-type`,
  name: 'mock-document-type',
  displayName: 'mock-document-type',
  filenamePrefix: null,
  classificationReviewThreshold: 0,
  extractionReviewThreshold: 0,
  borrowerReviewThreshold: 0,
  highConfThresh: 100,
  fields: new Array(5).fill(null).map((_, index) => ({
    id: `field-id-mock-document-type-${index}`,
    name: `Field ${index + 1} of mock-document-type`,
    type: index % 2 === 0 ? 'text' : 'number',
    code: `FIELD_CODE_mock-document-type-${index + 1}`,
    description: `Description for Field ${index + 1} of mock-document-type`,
    displayName: `Display Field ${index + 1} of mock-document-type`,
  })),
};

export const _mockDocument: Document = {
  id: crypto.randomUUID(),
  versionIdentifier:
    Object.values(VersionType)[
      Math.floor(0 * Math.min(Object.values(VersionType).length, 2))
    ],
  isNew: 0 % 2 === 0,
  isViewed: 0 % 3 === 0,
  isVerified: 0 % 5 === 0,
  userApproved: 0 % 5 === 0,
  name: _generateRandomDocumentName(0),
  documentTypeId: _mockDocumentType.id,
  confidence: 100,
  documentType: _mockDocumentType,
  version: 1,
  ..._getPageIdsAndFields(0),
  documentTypeConfidence: 100,
};
